export default "__VITE_ASSET__DapjSffS__"